import { useEffect, useState } from "react";
import tw from "tailwind-styled-components";
import { MdClose } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import { capitalizeFirstLetter } from "../../helpers";
import moment from "moment";
import { FaRegBuilding } from "react-icons/fa";
import { MdChevronRight } from "react-icons/md";
import { useLocation, useNavigate } from "react-router-dom";
import { capitalize } from "@mui/material";
import Config from "../../Config";

const statusOptions = [
    { value: 1, label: "Occupied" },
    { value: 2, label: "Moving Out" },
    { value: 3, label: "Reserved" },
    { value: 4, label: "Moved Out" },
    { value: 5, label: "Occupied" },

];

const statusMap = {
    [Config.OCCUPANCY_STATUS.PENDING]: "Pending",
    [Config.OCCUPANCY_STATUS.REQUESTED]: "Requested",
    [Config.OCCUPANCY_STATUS.OCCUPIED]: "Occupied",
    [Config.OCCUPANCY_STATUS.MOVING_OUT]: "Moving Out",
    [Config.OCCUPANCY_STATUS.RESERVED]: "Reserved",
};

const ViewTenantModal = ({
    handleClose,
    selectedData,
    apiData,
    setIsAddTenant,
}) => {
    const [height, setHeight] = useState(window.innerHeight);
    const navigate = useNavigate();
    // const location = useLocation();
    // const tenantStatus = location?.state?.tenantStatus;

    useEffect(() => {
        const handleResize = () => {
            setHeight(window.innerHeight);
        };

        window.addEventListener('resize', handleResize);
        handleResize();

        return () => {
            window.removeEventListener('resize', handleResize);
        };
    }, []);

    // Helper function to get stage color
    const getStageColor = (stage) => {
        const colors = {
            'Reserved': 'bg-blue-50 text-blue-700 border-blue-100',
            'Pending': 'bg-yellow-50 text-yellow-700 border-yellow-100',
            'Requested': 'bg-purple-50 text-purple-700 border-purple-100',
            'Occupied': 'bg-green-50 text-green-700 border-green-100',
            'Moving Out': 'bg-red-50 text-red-700 border-red-100',
        };
        return colors[stage] || 'bg-gray-50 text-gray-700 border-gray-100';
    };

    // Helper function to get follow-up status

    return (
        <Container style={{ height: `${height}px`, overflow: 'auto', WebkitOverflowScrolling: 'touch' }}>
            <Header>
                <h1 className="text-white text-lg font-medium">Tenant Summary</h1>
                <button onClick={handleClose}>
                    <MdClose color="white" size={24} />
                </button>
            </Header>
            <ProfileSection className="px-4 py-3 flex items-center justify-between">
                <div className="flex items-center gap-2">

                    <div className="w-11 h-11 rounded-xl bg-white shadow-sm flex items-center justify-center border border-gray-100">
                        <FaRegBuilding className="text-gray-500" />
                    </div>

                    {/* Text Info */}
                    <div className="flex flex-col">
                        <p className="text-md font-medium text-gray-800">
                            {capitalizeFirstLetter(selectedData?.inventoryName || "")}
                        </p>
                        <p className="text-xs text-gray-400">
                            {selectedData?.address || ""}
                        </p>
                    </div>

                </div>

                {/* Right: Deals */}
                {/* <div className="text-right">
                    <p className="text-xs text-gray-400">Tenant</p>
                    <p className="text-lg font-bold text-green-600">
                        ₹{selectedData?.count || 0}
                    </p>
                </div> */}
            </ProfileSection>
            <Content>
                {apiData?.length > 0 ? (
                    apiData.map((tenant, index) => {
                        // const statusName =
                        //     statusOptions.find((status) => status.value === tenant.status)?.label;
                        // const statusColor = getStageColor(statusName);
                        const statusName = statusMap[tenant.status] || "Unknown";
                        const statusColor = getStageColor(statusName);

                        return (
                            <DealCard
                                key={tenant.id || index}
                                onClick={() => {
                                    navigate(`/tenant/${tenant.tenantId}`);;
                                }}
                                className="cursor-pointer hover:shadow-md transition-all"
                            >
                                <CardHeader>
                                    <div className="flex items-center justify-between w-full">

                                        <ClientInfo>
                                            <div className="flex items-center gap-3">

                                                {/* Avatar */}
                                                <div className="w-10 h-10 rounded-full overflow-hidden bg-gray-100 flex items-center justify-center">
                                                    {tenant?.profileImage ? (
                                                        <img
                                                            src={tenant.profileImage}
                                                            alt="tenant"
                                                            className="w-full h-full object-cover"
                                                        />
                                                    ) : (
                                                        <span className="text-sm font-medium text-gray-500">
                                                            {(tenant.tenantName || tenant.name)?.charAt(0)?.toUpperCase()}
                                                        </span>
                                                    )}
                                                </div>

                                                {/* Name + Mobile */}
                                                <div className="flex flex-col">
                                                    <ClientName className="text-gray-800 font-medium">
                                                        {capitalizeFirstLetter(tenant.tenantName || "")}
                                                    </ClientName>

                                                    <ClientMobile>
                                                        {'#' + tenant.tenantMobile}
                                                    </ClientMobile>
                                                </div>

                                            </div>
                                        </ClientInfo>

                                        {/* Right Arrow */}
                                        <div className="flex flex-col items-end gap-1">
                                            <StageBadge className={statusColor}>
                                                {statusName}
                                            </StageBadge>
                                        </div>

                                    </div>
                                </CardHeader>
                                <div className="grid grid-cols-2 gap-3 mt-3">

                                    {/* Rent */}
                                    <div className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm">
                                        <span className="text-xs text-gray-400">Rent</span>
                                        <div className="text-base font-semibold text-gray-800 mt-1">
                                            ₹{tenant.rent || 0}
                                        </div>
                                    </div>

                                    {/* Security */}
                                    <div className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm">
                                        <span className="text-xs text-gray-400">Security</span>
                                        <div className="text-base font-semibold text-gray-800 mt-1">
                                            ₹{tenant.security || 0}
                                        </div>
                                    </div>

                                    {/* Move In */}
                                    <div className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm">
                                        <span className="text-xs text-gray-400">Move In</span>
                                        <div className="text-sm font-medium text-gray-700 mt-1">
                                            {tenant?.moveInDate
                                                ? moment(tenant.moveInDate).format("DD MMM, YYYY")
                                                : "N/A"}
                                        </div>
                                    </div>

                                    {/* Pending */}
                                    <div className="bg-white border border-gray-100 rounded-xl p-3 shadow-sm">
                                        <span className="text-xs text-gray-400">Pending</span>
                                        <div className={`text-base font-semibold mt-1 ${Number(tenant.pendingDues) > 0 ? "text-red-600" : "text-green-600"
                                            }`}>
                                            ₹{tenant.pendingDues || 0}
                                        </div>
                                    </div>

                                </div>

                                <div className="flex justify-end items-center mt-4 text-primary-color text-sm font-semibold group">
                                    View Details
                                    <MdChevronRight
                                        size={18}
                                        className="ml-1 transition-transform group-hover:translate-x-1"
                                    />
                                </div>
                                {/* <Footer>
                                    {tenant.updatedAt && (
                                        <span className="text-xs text-gray-400 ml-3">
                                            Last Updated: {moment(tenant.updatedAt).format('DD MMM YY')}
                                        </span>
                                    )}
                                </Footer> */}
                            </DealCard>
                        );
                    })
                ) : (
                    <EmptyState>
                        <p className="text-gray-400">No tenants available for this inventory</p>
                    </EmptyState>
                )}
            </Content>
        </Container>
    );
};

// Styled Components
const Container = tw.div`bg-white w-full h-full flex flex-col relative`;
//const Header = tw.div`flex items-center justify-between bg-primary-color py-4 px-4`;

const Header = tw.div`
  flex items-center justify-between px-5 py-4
  bg-gradient-to-r from-primary-color to-teal-400
  shadow-md
`;
//const ProfileSection = tw.div`flex items-center gap-3 bg-gray-100 px-4 p-4`;
const ProfileSection = tw.div`
  flex items-center gap-3 px-5 py-4
  bg-gradient-to-b from-gray-50 to-white
  border-b border-gray-100
`;
const Summary = tw.div`flex items-center`;
const SummaryItem = tw.div`flex flex-col items-end`;
const Content = tw.div`px-4 py-4 space-y-4 overflow-y-auto flex-1`;
//const DealCard = tw.div`bg-white border border-gray-200 rounded-lg p-4`;
const DealCard = tw.div`
  bg-white rounded-2xl p-4
  border border-gray-100
  shadow-sm hover:shadow-lg
  transition-all duration-200
`;
const CardHeader = tw.div`flex justify-between items-start mb-3`;
const ClientInfo = tw.div`flex flex-col`;
const ClientName = tw.div`flex items-center text-base font-medium text-gray-800`;
const ClientMobile = tw.div`flex items-center text-sm text-gray-500 mt-1`;
//const StageBadge = tw.span`text-xs px-3 py-1.5 rounded-full font-medium whitespace-nowrap`;
const StageBadge = tw.span`
  text-xs px-3 py-1.5 rounded-full font-medium
  border backdrop-blur-sm
`;
const EmptyState = tw.div`text-center text-gray-500 text-sm py-10`;
//const ContentBox = tw.div`flex justify-between items-center bg-gray-50 border border-gray-100 rounded-lg px-3 py-2 mt-3`;
const ContentBox = tw.div`
  flex justify-between items-center
  bg-white
  border border-gray-100
  rounded-xl
  px-4 py-3 mt-3
  shadow-sm
`;
const FabButton = tw.button`fixed bottom-6 right-6 w-14 h-14 bg-primary-color hover:bg-primary-color/80 text-white rounded-full flex items-center justify-center shadow-lg hover:shadow-xl transition-all duration-200 z-50`;

export default ViewTenantModal;